import * as types from "./types";
import {
  getTimesheetListAxios,
  deleteTimesheetAxios,
  postTimesheetAxios,
  putTimesheetAxios,
  getTimesheetIdAxios,
  getTimesheetbyStatusAxios,
  putTimesheetApprovalAxios,
} from "./services";

export async function getTimesheetListAction({ commit }) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    const { data } = await getTimesheetListAxios();
    commit(types.GET_TIMESHEET_LIST, data.result.data);
  } catch (e) {
    console.log(e);
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}

export async function getTimesheetIdAction({ commit }, payload) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    const { data } = await getTimesheetIdAxios(payload);
    commit(types.GET_TIMESHEET_ID, data.result);
  } catch (e) {
    console.log(e);
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}

export async function getTimesheetByStatusAction({ commit }, payload) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    const { data } = await getTimesheetbyStatusAxios(payload);
    commit(types.GET_TIMESHEET_BY_STATUS, data.result);
  } catch (e) {
    console.log(e);
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}


export async function removeTimesheetAction({ commit }, payload) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    await deleteTimesheetAxios(payload);
    commit(types.REMOVE_TIMESHEET, payload);
  } catch (e) {
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}

export async function addTimesheetAction({ commit }, payload) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    await postTimesheetAxios(payload);

    commit(types.ADD_TIMESHEET, payload);
  } catch (e) {
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}

export async function updateTimesheetAction({ commit }, payload) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    await putTimesheetAxios(payload);
    commit(types.UPDATE_TIMESHEET, payload);
  } catch (e) {
    console.log(e);
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}

export async function approvalTimesheetAction({ commit }, payload) {
  commit(types.LOADING_TIMESHEET, true);
  try {
    await putTimesheetApprovalAxios(payload);
    commit(types.TIMESHEET_APPROVAL, payload);
  } catch (e) {
    console.log(e);
    throw e;
  }
  commit(types.LOADING_TIMESHEET, false);
}
